import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl;

const getTransactionHistoryById = async (id, query) => {
  try {
    const data = await httpService.get(
      `${apiUrl}/members/transaction-history-all/${id}${
        query ? `?${query}` : ""
      }`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

const getTransactionHistory = async (id, query) => {
  try {
    const data = await httpService.get(
      `${apiUrl}/members/transaction-history/${id}${query ? `?${query}` : ""}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

const getTransactionLogAll = async (query) => {
  try {
    const data = await httpService.get(
      `${apiUrl}/members/transaction-history-all${query ? `?${query}` : ""}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

const exportLedger = async (queryString) => {
  try {
    const url = `${apiUrl}/members/transaction-history-all/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const exportTransaction = async (queryString) => {
  try {
    const url = `${apiUrl}/members/transaction-history-all/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const dmtReport = async (query) => {
  try {
    const data = await httpService.get(
      `${apiUrl}/billavenue/get-dmr-transaction-list${query ? `?${query}` : ""}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

const getSettlementList = async (query) => {
  try {
    const data = await httpService.get(
      `${apiUrl}/members/member-credit-settlement-list${
        query ? `?${query}` : ""
      }`
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
const exportSettlementList = async (queryString) => {
  try {
    const url = `${apiUrl}/members/member-credit-settlement-list/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const getCreditList = async (query) => {
  try {
    const data = await httpService.get(
      `${apiUrl}/members/credit-history-list${query ? `?${query}` : ""}`
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const exportCreditList = async (queryString) => {
  try {
    const url = `${apiUrl}/members/credit-history-list/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const getPaymentGatewayList = async (query) => {
  const data = await httpService.get(
    `${apiUrl}/members/paymentgateway-transaction-list${
      query ? `?${query}` : ""
    }`
  );
  return data;
};

const exportPaymentGatewayList = async (queryString) => {
  try {
    const url = `${apiUrl}/members/paymentgateway-transaction-list/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const PaymentRequery = async (values) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/paymentgateway/admin-transction-status`,
      values
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
const getAirportsList = async (query) => {
  const data = await httpService.get(
    `${apiUrl}/airports/all${query ? `?${query}` : ""}`
  );
  return data;
};
const addAirport = async (req) => {
  try {
    const url = `${apiUrl}/airports/add-airport`;
    const { data } = await httpService.post(url, req);
    return data;
  } catch (error) {
    throw error;
  }
};

const getAirlinesList = async (query) => {
  const data = await httpService.get(
    `${apiUrl}/flightcarrier/all-carrier${query ? `?${query}` : ""}`
  );
  return data;
};

const airlinesCommission = async (req) => {
  try {
    const url = `${apiUrl}/flightcarrier/add-flightcarrier-commission`;
    const { data } = await httpService.post(url, req);
    return data;
  } catch (error) {
    throw error;
  }
};
const addUpdateAirlines = async (req) => {
  try {
    const url = `${apiUrl}/flightcarrier/add-flight-carrier`;
    const { data } = await httpService.post(url, req);
    return data;
  } catch (error) {
    throw error;
  }
};

const getAirlinesCommission = async (id) => {
  try {
    const url = `${apiUrl}/flightcarrier/carrier-commission/${id ? id : ""}`;
    const { data } = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
export {
  getPaymentGatewayList,
  exportPaymentGatewayList,
  PaymentRequery,
  getTransactionHistoryById,
  getTransactionHistory,
  getTransactionLogAll,
  exportLedger,
  exportTransaction,
  dmtReport,
  getSettlementList,
  exportSettlementList,
  getCreditList,
  exportCreditList,
  getAirportsList,
  addAirport,
  getAirlinesList,
  airlinesCommission,
  getAirlinesCommission,
  addUpdateAirlines,
};
